import { supabase } from '../../../lib/supabase';
import { FreelancerSearchResult } from '../../../types/search';
import { JobSearchResult } from '../../../types/job';
import { SearchStrategy, FreelancerSearchParams, JobSearchParams } from '../SearchStrategy';
import { keyword_to_tsquery } from '../../../utils/searchUtils';

export class SupabaseFreelancerStrategy implements SearchStrategy<
  FreelancerSearchResult,
  FreelancerSearchParams
> {
  async search(params: FreelancerSearchParams) {
    const limit = params.limit_count || 20;
    const offset = params.offset_count || 0;

    const { data, error } = await supabase.rpc('search_freelancers', {
      keyword: keyword_to_tsquery(params.keyword || ''),
      filter_rating: params.filter_rating,
      filter_proximity: params.filter_proximity,
      filter_languages: params.filter_languages?.length ? params.filter_languages : null,
      filter_service_category_ids: params.filter_service_category_ids?.length
        ? params.filter_service_category_ids
        : null,
      filter_city_ids: params.filter_city_ids?.length ? params.filter_city_ids : null,
      sort_order: params.sort_order,
      limit_count: limit + 1,
      offset_count: offset,
      origin_lat: params.origin_lat,
      origin_lon: params.origin_lon,
    });

    if (error) throw error;

    const results = (data || []).slice(0, limit);
    const hasMore = (data?.length || 0) > limit;

    return { results, hasMore };
  }
}

export class SupabaseJobStrategy implements SearchStrategy<JobSearchResult, JobSearchParams> {
  async search(params: JobSearchParams) {
    const limit = params.limit_count || 20;
    const offset = params.offset_count || 0;

    const { data, error } = await supabase.rpc('search_jobs', {
      keyword: keyword_to_tsquery(params.keyword || ''),
      filter_languages: params.filter_languages?.length ? params.filter_languages : null,
      filter_city_ids: params.filter_city_ids?.length ? params.filter_city_ids : null,
      filter_service_category_slugs: params.filter_service_category_slugs?.length
        ? params.filter_service_category_slugs
        : null,
      filter_listing_type_ids: null,
      filter_on_site: null,
      sort_order: params.sort_order,
      limit_count: limit + 1,
      offset_count: offset,
    });

    if (error) throw error;

    const results = (data || []).slice(0, limit);
    const hasMore = (data?.length || 0) > limit;

    return { results, hasMore };
  }
}
